// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCacheToolRayType } from '@shared/commons/cache/DataCacheToolEnums';
import { ToolView } from './ToolView';
import { ToolViewUtils } from './Utils/ToolViewUtils';
import { TerceraChartToolRenderer } from '../Renderers/Tools/TerceraChartToolRenderer';
export class FibonacciExpansionToolView extends ToolView {
    DrawFib(gr, ww, highlight) {
        const pc = ww.PointsConverter;
        const clientRect = ww.ClientRectangle;
        const dataCacheTool = this.dataCacheTool;
        const fibLevel = dataCacheTool.fibLevel;
        const points = dataCacheTool.Points;
        const ray = dataCacheTool.RayType;
        const pen = highlight ? dataCacheTool.PenHighlight : dataCacheTool.Pen;
        const penRay = dataCacheTool.PenRay;
        const font = dataCacheTool.font;
        const fontColor = dataCacheTool.FontColor;
        const instrument = dataCacheTool.Instrument;
        const screenPoints = this.screenPoints;
        const scrP0 = screenPoints[0];
        const scrP0X = scrP0[0];
        const scrP0Y = scrP0[1];
        const scrP1 = screenPoints[1];
        const scrP1X = scrP1[0];
        const scrP1Y = scrP1[1];
        const scrP2 = screenPoints[2];
        const scrP2X = scrP2[0];
        const scrP2Y = scrP2[1];
        const p0 = points[0];
        // const p0X = p0[0];
        const p0Y = p0[1];
        const p1 = points[1];
        // const p1X = p1[0];
        const p1Y = p1[1];
        const p2 = points[2];
        // const p2X = p2[0];
        const p2Y = p2[1];
        const yDelta = p2Y - p1Y;
        const fibLevel_len = fibLevel.length;
        const levelsY = new Array(fibLevel_len);
        for (let i = 0; i < fibLevel_len; i++) {
            const fibLvl = fibLevel[i];
            // если уровень 0% - считать не надо ибо при делении на 0 => infinity
            if (fibLvl === 0)
                levelsY[i] = p2Y;
            else {
                const lambda = (fibLvl / 100 + 1) / (fibLvl / -100);
                levelsY[i] = (p0Y + lambda * p1Y) / (1 + lambda) + yDelta;
            }
        }
        // const dY = p1Y - p0Y;
        ToolView.DrawLineWithRay(gr, ww, scrP0X, scrP0Y, scrP1X, scrP1Y, DataCacheToolRayType.NoRay, pen);
        ToolView.DrawLineWithRay(gr, ww, scrP1X, scrP1Y, scrP2X, scrP2Y, DataCacheToolRayType.NoRay, pen);
        const dX = Math.abs(scrP2X - scrP1X);
        const minScrPX = Math.min(scrP0X, scrP1X);
        const right = Math.min(dX * 5 + minScrPX, clientRect.X + clientRect.Width);
        for (let i = 0; i < fibLevel_len; i++) {
            const fibLvl = fibLevel[i];
            if (isNullOrUndefined(fibLvl))
                continue;
            const cY = levelsY[i];
            const toolsRenderer = ww.GetRenderer(TerceraChartToolRenderer);
            const cYdraw = pc.GetScreenY(toolsRenderer.chart.cashItemSeriesSettings.CalculateConverter(cY));
            if (cYdraw > clientRect.Y && cYdraw < clientRect.Y + clientRect.Height) {
                ToolView.DrawLineWithRay(gr, ww, minScrPX, cYdraw, right, cYdraw, ray, pen, penRay);
            }
            // #18801. Drawings - мелкие доработки - показываем  цену каждого уровня слева
            let minPoint = minScrPX;
            minPoint = minPoint > clientRect.X ? minPoint : clientRect.X < right ? clientRect.X : right;
            // To prevent text-on-text overlay.
            if (!highlight && scrP0Y !== scrP1Y) {
                const price = ToolViewUtils.FormatPrice(instrument, cY);
                // #25534  FIbonacci retracement & expansions - подписи для линий скрывать когда данные тулзы уходят из поля зрения, т.е когда двигаем чарт в право
                if (minPoint < clientRect.X + clientRect.Width) {
                    const f_txt = ToolViewUtils.FormatFibonacciText(fibLvl, points, instrument) + '% (' + price + ')';
                    const wid = gr.GetTextWidth(f_txt, font);
                    if (ray === DataCacheToolRayType.LeftRay && dX * 5 + minScrPX > clientRect.X + clientRect.Width) {
                        ToolViewUtils.DrawFibonacciText(gr, ww, 1, cYdraw, f_txt, font, fontColor);
                    }
                    else {
                        ToolViewUtils.DrawFibonacciText(gr, ww, right - wid, cYdraw, f_txt, font, fontColor);
                    }
                }
            }
        }
    }
    Draw(gr, ww, param) {
        this.DrawFib(gr, ww, false);
        super.Draw(gr, ww, param);
    }
    DrawSelection(gr, ww) {
        this.DrawFib(gr, ww, true);
        const screenPoints = this.screenPoints;
        const p0 = screenPoints[0];
        const x0 = p0[0];
        const y0 = p0[1];
        const p1 = screenPoints[1];
        const x1 = p1[0];
        const y1 = p1[1];
        const p2 = screenPoints[2];
        const x2 = p2[0];
        const y2 = p2[1];
        this.DrawSelectedPoint(gr, ww, x0, y0);
        this.DrawSelectedPoint(gr, ww, x1, y1);
        this.DrawSelectedPoint(gr, ww, x2, y2);
        this.DrawSelectedLine(gr, ww, x0, y0, x1, y1);
        this.DrawSelectedLine(gr, ww, x1, y1, x2, y2);
    }
}
